export function constructorName(value: any): string | null {
  return typeof value.constructor === 'function'
    ? value.constructor.name
    : null;
}
